import * as Constants from 'resources/constants';
import { Minhac } from 'minhac-react-lib';
import * as FetchHelper from 'helpers/fetch';

class AppHelper {

    constructor()
    { 
        // this._webApiServerHostUrl= this._getWebApiHost();
    }  

    getWebApiHost() {        
        if (!this._webApiServerHostUrl)
            this._webApiServerHostUrl = this._getWebApiHost();
        return this._webApiServerHostUrl;
    }

    _getWebApiHost() {   
        let defaultValue = Constants.WebApiServerHostUrlDefault;
        let addSufixWebApiHost = Minhac.Util.getMinhacValue("minhac.settings.addSufix", true);
        let ServicesUrlKey = Constants.ServicesUrlKey;
        let ret = Minhac.Util.getWebApiPath(ServicesUrlKey, defaultValue, false);
        
        if (ret != defaultValue && addSufixWebApiHost) {
            ret = `${ret}/MINHAC_REGISTRY_SERVICES`;            
        }

        return ret;
    }   
    
    getLanguage(url) {
        let ret = Constants.Constants.Keys.DefaultLanguage;

        try {
            if (_spPageContextInfo) {
                ret = _spPageContextInfo.currentCultureName;
            }
            else {
                let matchUrl = /\/(?<lang>\w{2}-\w{2})\//.exec(url);
                if (matchUrl) {
                    ret = matchUrl.groups['lang'];
                }            
            }
        }
        catch (error) {
        }        

        return ret;
    }
}

export default AppHelper;

export let helper = new AppHelper();